import { Component, ViewChild,Input, OnInit } from '@angular/core';
/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';

/*Services*/
import { ShareDeviceService, ObservableObjectsService } from "@services"

import { Device, ShareRequest, ObservableObject } from '@models';

import { ObjectsService } from '@services/http/objects.service';

import { CachedDataService } from '@services/data/cached-data.service';

import { CONFIG } from '../../../config';
declare var swal: any;

@Component({
  selector: 'app-share-device-cancel-modal',
  templateUrl: './share-device-cancel-modal.component.html'
})

export class ShareDeviceCancelModalComponent implements OnInit {

  @ViewChild('shareDeviceModal') shareDeviceModal: BsModalComponent;
  currentRequest: ShareRequest;
  errorMessage: string;
  trySubmit = false;
  btnText: any = {
    text: 'Отменить',
    defaultText: 'Отменить',
    loadText: 'Отмена..'
  };

  observableObjects: ObservableObject[];

  constructor(private shareDeviceService: ShareDeviceService, private objectsService: ObjectsService, private cachedDataService: CachedDataService, private observableObjectsService: ObservableObjectsService){}


  ngOnInit(){
  
  }
  initForm(){
  }
  

	submit(){
		this.trySubmit = true;
        

        this.shareDeviceService.confirmShareDevice(this.currentRequest.deviceId, this.currentRequest.slaveUserId,"declined")
            .subscribe(response => {
                    this.shareDeviceService.updateRequestsSubject.next(null)
                    this.btnText.text = this.btnText.defaultText;
                    this.trySubmit  = false;
                    this.btnText.text = this.btnText.defaultText;

                    swal({
                        type: 'success',
                        text: 'Заявка отменена',
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    this.close();
                },
                error => {
                    this.btnText.text = this.btnText.defaultText;
                    let errorMessage = 'Ошибка, повторите позже';
                    if (error.error && error.error.errorMessage) {
                        errorMessage = error.error.errorMessage;
                    }
                    this.errorMessage = errorMessage;
                    this.trySubmit = false;
                    this.btnText.text = this.btnText.defaultText;
                }
            );


        
		this.btnText.text = this.btnText.loadText;
		this.errorMessage = null;
	}

  	open(request: ShareRequest) {
		this.initForm();
		this.currentRequest = request;
		this.shareDeviceModal.open();
	}

	close() {
		this.shareDeviceModal.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/view/modal/share-device-cancel-modal/share-device-cancel-modal.component.ts